<template>
  <div>
    <div id="footer">
      <div class="footer_1">
        <div class="footer_1_left">
          <div class="title">白天精力好 晚上睡得香</div>
          <div class="subtitle">&emsp;</div>
        </div>
        <div class="footer_1_right">
          <a href="http://e.tb.cn/h.gEW4kkPBhpwM0Kw?tk=wlAu3lQH1Ei CZ0000"
            ><button type="button">购买</button></a
          >
        </div>
      </div>
      <div class="divider"></div>
      <div class="footer_2">
        <div class="footer_2_left">
          <div>
            <p>精力舱</p>
            <ul>
              <!-- <li @click="toguid('/device', 'user_pain_points')">用户痛点</li>
              <li @click="toguid('/device', 'improvement_effect')">效果</li>
              <li @click="toguid('/device', 'usage_scenario')">使用场景</li>
              <li @click="toguid('/device', 'application_program')">
                应用程序
              </li> -->
              <li @click="toguid('/lotus1device', 'lotus1device')">
                LOTUS 1 经典版
              </li>
              <li @click="toguid('/lotus2device', 'lotus2device')">
                LOTUS 2 能量版
              </li>
              <li @click="toguid('/lotus2Rdevice', 'lotus2Rdevice')">
                LOTUS 2R 认知版
              </li>
            </ul>
          </div>
          <div>
            <p>技术原理</p>
            <ul>
              <!-- <li @click="toguid('/mood', 'working_principle')">工作原理</li>
              <li @click="toguid('/mood', 'principles_of_technology')">
                科技原理
              </li> -->
              <li @click="toguid('/mood', 'patent_certificate')">专利证书</li>
              <li @click="toguid('/mood', 'working_principle')">工作原理</li>
            </ul>
          </div>
          <!-- <div>
            <p>用户反馈</p>
            <ul>
              <li @click="toguid('/sleep', 'rave_reviews')">好评如潮</li>
            </ul>
          </div> -->
          <div>
            <p>关于我们</p>
            <ul>
              <!-- <li @click="toguid('/home', 'company')">公司发展历程</li>
              <li @click="toguid('/home', 'founder')">创始人介绍</li>
              <li @click="toguid('/home', 'device')">精力舱</li>
              <li @click="toguid('/home', 'join_us')">加入我们</li> -->
              <li @click="toguid('/home', 'company')">公司发展历程</li>
              <li @click="toguid('/home', 'founder')">创始人介绍</li>
              <li @click="toguid('/home', 'team')">我的团队</li>
              <li @click="toguid('/home', 'comment')">精力舱好评</li>
            </ul>
          </div>
        </div>
        <div class="footer_2_right">
          <div class="email">
            <div class="email_content">
              <div class="email_copy">
                <div id="email_num">400-686-8960</div>
                <img src="../../assets/icon_Copy.png" @click="copyEmail()" />
              </div>
            </div>
          </div>
          <div class="weChat">
            <div class="wechat_content">
              <img src="../../assets/wechat_qrcode.png" />
              <div>扫码关注微信公众号：般意</div>
            </div>
          </div>
          <a href="https://weibo.com/u/2124970203">
            <div class="weBo"></div>
          </a>
          <div class="tiktok">
            <div class="tiktok_content">
              <img src="../../assets/QR_tiktok.png" />
              <div>扫码关注抖音号: cool_brain</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_3">
        版权所有杭州般意科技有限公司 ©Copyright 2019-{{ year }}. All Rights
        Reserved. 浙ICP备2023041842号-3
      </div>
      <!-- <div class="cont">
        <div class="bo1">
          <div class="fotitle">联系我们</div>
          <div style="margin-top: 1.7vw; margin-bottom: 0.5vw">地址</div>
          <div>杭州华润大厦B座23楼</div>
        </div>
        <div class="bo2">
          <div style="margin-bottom: 0.5vw">
            <img class="tab2Img1" :src="require('./../../assets/11.png')" />
            邮箱
          </div>
          <div>editor@coolbrainscience.com</div>
          <div style="margin-top: 1.2vw; margin-bottom: 0.5vw">
            <img class="tab2Img1" :src="require('./../../assets/12.png')" />微信号
          </div>
          <div>brain_assisstant1</div>
        </div>
        <div class="bo3">
          <div>关于我们</div>
          <div>商业合作</div>
          <div>加入我们</div>
          <div>用户协议</div>
          <div>隐私政策</div>
        </div>
      </div> -->
      <!-- <div class="foot">
        版权所有杭州般意科技有限公司 ©Copyright 2019-2023. All Rights Reserved. 浙ICP备2021039003号-1
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      year: "",
    };
  },
  mounted() {
    this.getYear();
  },
  methods: {
    toguid(path, id) {
      if (path == this.$route.path) {
        let toElement = document.getElementById(id);
        toElement.scrollIntoView();
      } else {
        window.sessionStorage.setItem("toId", id);
        this.$router.push(path);
      }
      // var path = path
      // var Id = id
      // window.localStorage.setItem('toId', Id)
      // window.sessionStorage.setItem('toId', Id)
      // this.$router.push(path)
    },
    copyEmail() {
      var email = document.getElementById("email_num").innerText;
      var oInput = document.createElement("input");
      oInput.value = email;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("copy");
      oInput.className = "oInput";
      oInput.style.display = "none";
      alert("复制成功");
    },
    getYear() {
      const time = new Date();
      this.year = time.getFullYear();
    },
  },
};
</script>
<!-- <style src="./footerInfo.css" scoped></style> -->
<style scoped>
#footer {
  width: 100vw;
  height: 33.38vw;
  background: #1b1e8a;
  position: relative;
}

.footer_1 {
  overflow: hidden;
  margin: 0 13.3vw;
}

.footer_1_left {
  float: left;
  margin-top: 7.8vw;
}

.footer_1_right {
  float: right;
  margin-top: 7.8vw;
}

.title {
  font-family: "SourceHanSansCN-Bold";
  font-weight: bold;
  font-size: 2.5vw;
  color: #ffffff;
}

.subtitle {
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  font-size: 0.9vw;
  color: #ffffff;
}

.footer_1_right button {
  width: 10.2vw;
  height: 3.1vw;
  border-radius: 0.3vw;
  background-color: #888ef9;
  color: #ffffff;
  border: none;
  font-size: 0.8vw;
  margin-top: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
}

.divider {
  border-top: 0.05vw solid #ffffff;
  margin: 3.4vw 13.3vw 2.6vw 13.3vw;
}

.footer_2 {
  position: relative;
  margin-left: 13.3vw;
}

.footer_2_left div {
  display: inline-block;
  vertical-align: top;
  color: #ffffff;
  margin-right: 7.3vw;
}

.footer_2_left p {
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 0.9vw;
  margin-bottom: 1.1vw;
}

ul {
  margin: 0;
  padding: 0;
}

ul > li {
  list-style-type: none;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  font-size: 0.8vw;
  cursor: pointer;
}

.footer_2_right {
  position: absolute;
  right: 13.3vw;
  top: 0;
}

.footer_2_right .email,
.footer_2_right .weChat,
.footer_2_right .weBo,
.footer_2_right .tiktok {
  width: 2.2vw;
  height: 2.2vw;
  display: inline-block;
  margin-left: 0.45vw;
  position: relative;
}

.email {
  background: url(../../assets/phone.png) no-repeat;
  background-size: 100% 100%;
}

.email:hover,
.email:active,
.email:focus {
  background: url(../../assets/phone.png) no-repeat;
  background-size: 100% 100%;
}

.weChat {
  background: url(../../assets/WeChat.png) no-repeat;
  background-size: 100% 100%;
}

.weChat:hover,
.weChat:active,
.weChat:focus {
  background: url(../../assets/WeChat-purple.png) no-repeat;
  background-size: 100% 100%;
}

.weBo {
  background: url(../../assets/Webo.png) no-repeat;
  background-size: 100% 100%;
}

.weBo:hover,
.weBo:active,
.weBo:focus {
  background: url(../../assets/Webo-purple.png) no-repeat;
  background-size: 100% 100%;
}

.tiktok {
  background: url(../../assets/tiktok.png) no-repeat;
  background-size: 100% 100%;
}

.tiktok:hover,
.tiktok:active,
.tiktok:focus {
  background: url(../../assets/tiktok-purple.png) no-repeat;
  background-size: 100% 100%;
}

.email .email_content,
.weChat .wechat_content,
.tiktok .tiktok_content {
  visibility: hidden;
}

.email:hover .email_content,
.email:active .email_content,
.email:focus .email_content,
.weChat:hover .wechat_content,
.weChat:active .wechat_content,
.weChat:focus .wechat_content,
.tiktok:hover .tiktok_content,
.tiktok:active .tiktok_content,
.tiktok:focus .tiktok_content {
  visibility: visible;
}

.email_content {
  position: absolute;
  top: 3.4vw;
  width: 18.75vw;
  height: 2.92vw;
  background: #ffffff;
  box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.32);
}

.email_copy {
  margin: 0 1.25vw;
  position: relative;
}

.email_copy div {
  color: #333333;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  line-height: 2.92vw;
}

.email_copy img {
  width: 1.25vw;
  height: 1.25vw;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.wechat_content,
.tiktok_content {
  position: absolute;
  top: 3.4vw;
}

.wechat_content img,
.tiktok_content img {
  width: 9.4vw;
  height: 11.9vw;
}

.wechat_content div,
.tiktok_content div {
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  color: #333333;
  text-align: center;
  margin: -3.7vw 0.8vw 0 0.8vw;
}

.footer_3 {
  color: #ffffff;
  font-size: 0.78vw;
  position: absolute;
  bottom: 2.1vw;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  opacity: 0.5;
}
</style>
<!--<style scoped>
  /* .fotitle {
    font-size: 1.2vw;
    font-family: 'fontmedium';
    font-weight: 500;
    color: #ffffff;
  }

  .bo1 {
    cursor: pointer;
    margin: 3.2vw 8.7vw;
    margin-bottom: 0;
  }

  .bo2 {
    cursor: pointer;
    margin: 4vw 4.8vw;
    margin-bottom: 0;
  }

  .bo3 {
    cursor: pointer;
    display: flex;
    margin: 6.7vw 3.8vw;
    margin-bottom: 0;
  }

  .bo3 div {
    margin-right: 3.8vw;
  }

  .cont {
    font-size: 1vw;
    font-family: 'fontregular';
    font-weight: 400;
    color: rgba(255, 255, 255, 0.41);
    display: flex;
  }

  .foot {
    text-align: center;
    font-size: 0.8vw;
    font-family: 'fontregular';
    font-weight: 400;
    background: #90a799;
    color: rgba(255, 255, 255, 0.41);
    padding-top: 1.5vw;
    padding-bottom: 2vw;
  }

  .tab2Img1 {
    width: 1.2vw;
    height: 0.9vw;
    margin-left: -2vw;
    margin-right: 0.5vw;
    display: inline-block;
    vertical-align: middle;
  }

  .tab2Img2 {
    width: 1.5vw;
    height: 1.3vw;
    margin-left: -2vw;
    margin-right: 0.5vw;
    display: inline-block;
    vertical-align: middle;
  } */
</style>-->



// WEBPACK FOOTER //
// src/components/common/FooterInfo.vue